// Test IDs for the unmanipulated analysis features.
export const NAV = {
  home: 'nav-home',
  live: 'nav-live',
  profile: 'nav-profile',
  history: 'nav-history',
  docs: 'nav-docs',
};

export const ANALYZE = {
  conversationInput: 'analyze-conversation-input',
  contextInput: 'analyze-context-input',
  runButton: 'analyze-run-button',
  uploadInput: 'analyze-upload-input',
  uploadDrop: 'analyze-upload-drop',
  clearButton: 'analyze-clear-button',
  reportPanel: 'analyze-report-panel',
  riskScore: 'analyze-risk-score',
  riskLabel: 'analyze-risk-label',
  summaryText: 'analyze-summary-text',
  tacticsList: 'analyze-tactics-list',
  harmsList: 'analyze-harms-list',
  benefitsList: 'analyze-benefits-list',
  actionsList: 'analyze-actions-list',
};

export const LIVE = {
  startButton: 'live-start-button',
  stopButton: 'live-stop-button',
  transcriptBox: 'live-transcript-box',
  hudPanel: 'live-hud-panel',
  hudScore: 'live-hud-score',
  hudAlert: 'live-hud-alert',
  clearButton: 'live-clear-button',
  speakerToggle: 'live-speaker-toggle',
};

export const PROFILE = {
  bioInput: 'profile-bio-input',
  postsInput: 'profile-posts-input',
  notesInput: 'profile-notes-input',
  uploadInput: 'profile-upload-input',
  runButton: 'profile-run-button',
  reportPanel: 'profile-report-panel',
};

export const HISTORY = {
  list: 'history-list',
  refreshButton: 'history-refresh-button',
  itemPrefix: 'history-item-',
  deletePrefix: 'history-delete-',
};
